
import React, { useState, useEffect, useContext } from 'react';
import clockIconFill from "../assets/images/clockIconFill.png";
import { HoleContext } from "./HoleContext";

const SimplifiedTimer = () => {
  // const { currentHole, serverRoundDuration } = useContext(HoleContext);
  const { currentHole, serverRoundDuration } = useContext(HoleContext);
  const [times, setTimes] = useState({ round: 0, hole: 0 });
  const [activeGameHole, setActiveGameHole] = useState(1);
  const [isRunning, setIsRunning] = useState(false);

  const getGameId = () => window.location.pathname.split('/').pop();
  const storageKey = "activeGameHoles";

  // Load saved times from localStorage
  useEffect(() => {
    const gameId = getGameId();
    console.log("ImprovedTimer","currenthole", currentHole, "Active HOLE", activeGameHole, "Server Durratioon", serverRoundDuration )
    try {
      const storedGames = JSON.parse(localStorage.getItem(storageKey)) || {};

      if (storedGames[`game_${gameId}`]) {
        const gameData = storedGames[`game_${gameId}`];

        setActiveGameHole(gameData.ActiveHole || 1);
        console.log("fetchimproved g hole active", gameData.ActiveHole)
        if(serverRoundDuration){
          setTimes({
            round: serverRoundDuration,
            hole: gameData[`hole${currentHole}`] || 0,
          });
        } else {
          setTimes({
            round: gameData.RoundTime || 0,
            hole: gameData[`hole${currentHole}`] || 0,
          });
        }

      } else {
        storedGames[`game_${gameId}`] = { ActiveHole: currentHole, RoundTime: 0, [`hole${currentHole}`]: 0 };
        localStorage.setItem(storageKey, JSON.stringify(storedGames));
      }
    } catch (error) {
      console.error("Error loading game data:", error);
    }
  }, [currentHole]);

  // Increment timers only when currentHole === activeGameHole
  useEffect(() => {
    if (currentHole !== activeGameHole) {
      setIsRunning(false);
      return;
    }
    
    setIsRunning(true);
    const interval = setInterval(() => {
      setTimes(prev => {
        const updatedTimes = {
          round: prev.round + 1,
          hole: prev.hole + 1,
        };

        // Save updated times in localStorage
        const gameId = getGameId();
        const storedGames = JSON.parse(localStorage.getItem(storageKey)) || {};
        if (!storedGames[`game_${gameId}`]) storedGames[`game_${gameId}`] = {};

        storedGames[`game_${gameId}`].RoundTime = updatedTimes.round;
        storedGames[`game_${gameId}`][`hole${currentHole}`] = updatedTimes.hole;

        localStorage.setItem(storageKey, JSON.stringify(storedGames));

        return updatedTimes;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [currentHole, activeGameHole]);


const formatTime = (seconds = 0) => {
  if (seconds > 31536000) seconds = 0;

  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = Math.floor(seconds % 60).toString().padStart(2, '0');

  // Only include hours if they're not zero
  if (h > 0) {
    return `${h}:${m}:${s}`;
  } else {
    return `${m}:${s}`;
  }
};

  return (
  <div className="d-flex align-items-center gap-3">
  <span className="text-white">Round {formatTime(times.round)}</span>
  <span className="text-white">Hole {formatTime(times.hole)}</span>
</div>
  );
};

export default SimplifiedTimer;
